module.exports = __webpack_public_path__ + "static/b1-ebro-dad8f9aedb9a16b465981a7d56823ea8.jpg";